module.exports = __webpack_public_path__ + "img/main-page-rating-section-arrow-down.718c9343.svg";